module.exports = __webpack_public_path__ + "img/e0bef3dd18ad091ac85413f98a0eec1c.924e51fb.png";